import script from "./UsuarioRooming.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioRooming.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioRooming.vue?vue&type=style&index=0&id=dcdb17f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcdb17f8"]])

export default __exports__